import { render } from "./MapyCzBasicLayer.vue?vue&type=template&id=36f87bb3&ts=true"
import script from "./MapyCzBasicLayer.vue?vue&type=script&lang=ts"
export * from "./MapyCzBasicLayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__